import { render } from "./realisasi_anggaran_2025.vue?vue&type=template&id=f12dee36&scoped=true"
import script from "./realisasi_anggaran_2025.vue?vue&type=script&lang=js"
export * from "./realisasi_anggaran_2025.vue?vue&type=script&lang=js"

import "./realisasi_anggaran_2025.vue?vue&type=style&index=0&id=f12dee36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f12dee36"]])

export default __exports__